/* Benpasso: carosello recensioni, schede FAQ, video che partono quando sono visibili */
(() => {
  if (window.__benpassoLoaded) return;
  window.__benpassoLoaded = true;

  if (!customElements.get('bp-carousel')) {
    customElements.define('bp-carousel', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        this.slides = [...this.track.children];
        this.dots = this.querySelector('[data-dots]');
        this.dots.innerHTML = '';
        this.slides.forEach((_, i) => {
          const b = document.createElement('button');
          b.type = 'button';
          b.className = 'bp-carousel__dot';
          b.setAttribute('aria-label', 'Vai alla recensione ' + (i + 1));
          b.addEventListener('click', () => this.go(i));
          this.dots.appendChild(b);
        });
        this.querySelector('[data-prev]').addEventListener('click', () => this.go(this.index() - 1));
        this.querySelector('[data-next]').addEventListener('click', () => this.go(this.index() + 1));
        this.track.addEventListener('scroll', () => this.mark(), { passive: true });
        this.mark();
      }
      index() {
        const w = this.slides[0]?.getBoundingClientRect().width || 1;
        return Math.round(this.track.scrollLeft / w);
      }
      go(i) {
        const n = this.slides.length;
        const target = this.slides[(i + n) % n];
        this.track.scrollTo({ left: target.offsetLeft - this.track.offsetLeft, behavior: 'smooth' });
      }
      mark() {
        const i = this.index();
        [...this.dots.children].forEach((d, k) => d.setAttribute('aria-current', k === i ? 'true' : 'false'));
      }
    });
  }

  if (!customElements.get('bp-slider')) {
    customElements.define('bp-slider', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        this.slides = [...this.track.children];
        this.dots = this.querySelector('[data-dots]');
        this.dots.innerHTML = '';
        this.slides.forEach((_, i) => {
          const b = document.createElement('button');
          b.type = 'button';
          b.className = 'bp-carousel__dot';
          b.setAttribute('aria-label', 'Vai al video ' + (i + 1));
          b.addEventListener('click', () => this.go(i));
          this.dots.appendChild(b);
        });
        this.querySelector('[data-prev]').addEventListener('click', () => this.go(this.index() - 1));
        this.querySelector('[data-next]').addEventListener('click', () => this.go(this.index() + 1));
        this.track.addEventListener('scroll', () => this.mark(), { passive: true });
        this.mark();
      }
      index() {
        const left = this.track.scrollLeft;
        let best = 0;
        this.slides.forEach((s, i) => { if (Math.abs(s.offsetLeft - this.track.offsetLeft - left) < Math.abs(this.slides[best].offsetLeft - this.track.offsetLeft - left)) best = i; });
        return best;
      }
      go(i) {
        const n = this.slides.length;
        const target = this.slides[(i + n) % n];
        this.track.scrollTo({ left: target.offsetLeft - this.track.offsetLeft - parseFloat(getComputedStyle(this.track).paddingLeft || 0), behavior: 'smooth' });
      }
      mark() {
        const i = this.index();
        [...this.dots.children].forEach((d, k) => d.setAttribute('aria-current', k === i ? 'true' : 'false'));
      }
    });
  }

  if (!customElements.get('bp-tabs')) {
    customElements.define('bp-tabs', class extends HTMLElement {
      connectedCallback() {
        this.tabs = [...this.querySelectorAll('[role="tab"]')];
        this.tabs.forEach((tab, i) => {
          tab.addEventListener('click', () => this.select(tab));
          tab.addEventListener('keydown', (e) => {
            if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
            const next = this.tabs[(i + (e.key === 'ArrowRight' ? 1 : -1) + this.tabs.length) % this.tabs.length];
            next.focus();
            this.select(next);
          });
        });
      }
      select(tab) {
        this.tabs.forEach((t) => {
          const on = t === tab;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
          const panel = this.querySelector('[data-panel="' + t.dataset.cat + '"]');
          if (panel) panel.hidden = !on;
        });
      }
    });
  }

  // bp-open-size-guide: il link "Guida alle taglie" apre il riquadro
  document.addEventListener('click', (e) => {
    const a = e.target.closest('a[href="#guida-taglie"]');
    const box = document.getElementById('guida-taglie');
    if (!a || !box || box.tagName !== 'DETAILS') return;
    e.preventDefault();
    box.open = true;
    box.scrollIntoView({ behavior: 'smooth', block: 'center' });
  });

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const startVideos = () => {
    const videos = document.querySelectorAll('video[data-bp-autoplay]:not([data-bp-watched])');
    if (!videos.length) return;
    const io = new IntersectionObserver((entries) => {
      entries.forEach(({ isIntersecting, target }) => {
        if (isIntersecting) {
          if (target.preload === 'none') target.preload = 'auto';
          if (!reduceMotion) target.play().catch(() => {});
        } else {
          target.pause();
        }
      });
    }, { rootMargin: '150px 0px' });
    videos.forEach((v) => {
      v.dataset.bpWatched = 'true';
      if (reduceMotion) v.setAttribute('controls', '');
      io.observe(v);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', startVideos);
  else startVideos();
  document.addEventListener('shopify:section:load', startVideos);
})();
